import React, {lazy, Suspense} from 'react';

import TagManager from 'react-gtm-module';

import {shouldRenderLandings} from 'src/landings/paths';

import {GTM_ID} from './constants';

const tagManagerArgs = {gtmId: GTM_ID};

TagManager.initialize(tagManagerArgs);

const AppShell = lazy(() => import('./AppShell'));
const LandingsApp = lazy(() => import('./landings/LandingsApp'));

// Both halves are dynamic imports so each request downloads only its own side.
// Decided from `window.location` before any router mounts, because it has to
// happen before `AppRouter`'s `startChecking()` auth gate. See docs/landings.md.
function App() {
  const isLanding = shouldRenderLandings({
    host: window.location.host,
    pathname: window.location.pathname,
  });

  return (
    <Suspense fallback={null}>
      {isLanding ? <LandingsApp /> : <AppShell />}
    </Suspense>
  );
}

export default App;
